import config from '@site-config/config.json';

const useSiteConfig = () => {
	return config;
};

export default useSiteConfig;